// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._2c3YgpQxx{padding:8px 0;position:relative}._2c3YgpQxx:first-child{padding-top:0}._2c3YgpQxx::before{content:'';position:absolute;top:0;left:8px;right:8px;height:1px;background-color:var(--ui-divider)}@media screen and (-ms-high-contrast: active){._2c3YgpQxx::before{background-color:windowText}}._2c3YgpQxx:first-child::before{display:none}._2c3YgpQxx:last-child{padding-bottom:0}._2yZPbg7nx{padding-top:16px}._2yZPbg7nx:first-child{padding-top:4px}._4Zc6YgcGx::before{background-color:rgba(255,255,255,0.1)}._3vP5ySzsx{}._3vP5ySzsx:empty{display:none}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"item-group": "_2c3YgpQxx",
	"itemGroup": "_2c3YgpQxx",
	"with-title": "_2yZPbg7nx",
	"withTitle": "_2yZPbg7nx",
	"dark": "_4Zc6YgcGx",
	"title": "_3vP5ySzsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-list-xs"] + ""
};
module.exports = exports;
